import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import { getCurrentApp } from '../config';
import { findRoute, getRouteFor } from './route-helpers';

/*
  This component is a wrapper for linking across and inside apps.

  AppLink automatically detects if the route passed is inside or outside the
  current app, and creates a Link or <a> tag according to the case.

  NOTE: this component is only useful for routing inside the apps
  defined in this project. To link outside, use <a></a> tags as usual.
*/

const IPropTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.element,
  ]).isRequired,
  className: PropTypes.string,
  pathParams: PropTypes.object,
  queryParams: PropTypes.object,
  routeName: PropTypes.string.isRequired,
  targetBlank: PropTypes.bool,
};

const defaultProps = {
  className: '',
  pathParams: {},
  queryParams: {},
  targetBlank: false,
};

const AppLink = (props) => {
  const currentApp = getCurrentApp();
  const route = findRoute(props.routeName);
  const routePath = getRouteFor(props.routeName, props.pathParams, props.queryParams);
  let component = null;
  let targetBlankProps = {};
  if (props.targetBlank) {
    targetBlankProps = {
      target: '_blank',
      rel: 'noopener noreferrer',
    };
  }
  if (route.app === currentApp) {
    component = (
      // Seems that jsx-a11y does not like Link components without href attributes, but since
      // the router uses this naming, we have to disable the rule here.
      /* eslint-disable-next-line jsx-a11y/anchor-is-valid */
      <Link
        className={props.className}
        to={routePath}
        {...targetBlankProps}
      >
        {props.children}
      </Link>
    );
  } else {
    component = (
      <a
        className={props.className}
        href={routePath}
        {...targetBlankProps}
      >
        {props.children}
      </a>
    );
  }
  return component;
};

AppLink.propTypes = IPropTypes;
AppLink.defaultProps = defaultProps;

export { AppLink };



// WEBPACK FOOTER //
// ./src/routes/AppLink.jsx